/**
 * Homepage ODX hub: keep #MainContent flush to the viewport top (Y=0) so content sits under the
 * fixed HUD header. Pairs with `window.odxIsMainFlushLayout` from `odx-head-scripts` and
 * `#MainContent.odx-main--flush` in `odx-header-center-nav.css`.
 */
(function () {
  'use strict';

  function run() {
    if (typeof window.odxIsMainFlushLayout !== 'function' || !window.odxIsMainFlushLayout()) return;
    var main = document.getElementById('MainContent');
    if (!main) return;
    main.classList.add('odx-main--flush');
    try {
      main.style.removeProperty('--header-height');
    } catch (e) {}
    main.classList.remove('site-header-transition');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
